/** Resolves gallery URLs for carousel display (gallery first, then hero image). */
export function getCampaignImageUrls(campaign) {
  if (!campaign) return [];
  if (Array.isArray(campaign.galleryImages) && campaign.galleryImages.length > 0) {
    return campaign.galleryImages;
  }
  if (campaign.image) {
    return [campaign.image];
  }
  return [];
}
